export const DEFAULT_VALUES = {
  DEFAULT_LANGUAGE_ID: '36ac9921-b7a3-4223-82d3-7b992b4f9cc3',
};
